import React from 'react';
import { RoundButton } from '../../../libs/components/RoundButton';

export default function Action({ text, icon, link , color , fontColor}){

    return(
        <RoundButton text={text} icon={icon} link={link} color={color} fontColor={fontColor} />
    )
}